"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authLoaded = void 0;

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var _dispatch = require("crm_data/flux/dispatch");

var authLoaded = function authLoaded(auth) {
  return (0, _dispatch.dispatch)(_ActionTypes.default.AUTH_LOADED, auth);
};

exports.authLoaded = authLoaded;